import { render, staticRenderFns } from "./return-handle.vue?vue&type=template&id=6aec6134&scoped=true&"
import script from "./return-handle.vue?vue&type=script&lang=ts&"
export * from "./return-handle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aec6134",
  null
  
)

export default component.exports